import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import * as utils from "../../Utils/comman";
import CustomPagination from "../../Utils/CustomPagination";
import Select from "react-select";
import { DocumentDownload } from "iconsax-react";

function OnReChallan({ activeTab }) {
  const [preChallanData, setPreChallanData] = useState([]);

  const [isReset, setIsReset] = useState(false);
  const [isFind, setIsFind] = useState(false);

  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [page, setPage] = useState(1);
  const countPerPage = 10;

  useEffect(() => {
    if (activeTab == "onReChallan") {
      fetchPreChallanData();
      fetchProductList();
    }
  }, [activeTab, page]);

  const fetchPreChallanData = () => {
    utils
      .callAPI(
        "get",
        `production/process/get-holdstock-list?page=${page}&per_page=${countPerPage}&product_id=${
          Object.keys(selectedProduct).length !== 0
            ? selectedProduct?.value
            : ""
        }`
      )
      .then((res) => {
        setPreChallanData(res || []);
        setIsFind(false);
        setIsReset(false);
      })
      .catch(() => {
        setPreChallanData([]);
        setIsReset(false);
        setIsFind(false);
      });
  };

  const fetchProductList = useCallback(() => {
    utils
      .callAPI("get", "/Product/list")
      .then((res) => setProductList(res?.result || []))
      .catch(() => setProductList([]));
  }, []);

  const options = productList?.map((prod) => ({
    value: prod.id,
    label: prod.productCode
      ? `${prod.product_name} (${prod.productCode})`
      : prod.product_name,
    productCode: prod.productCode,
  }));

  const handleProductSelection = (selected) => {
    setSelectedProduct(selected);
  };

  const columns = [
    { name: "Product Name", selector: (row) => row.productname },
    { name: "Product Code", selector: (row) => row.productCode },
    { name: "Quantity", selector: (row) => row.dr_qty },
    { name: "Sales Order Number", selector: (row) => row.order_id },
  ];

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSearch = () => {
    setIsFind(true);
  };

  const handleReset = () => {
    setSelectedProduct("");
    setIsReset(true);
  };

  useEffect(() => {
    if (isReset) {
      fetchPreChallanData();
    }
    if (isFind) {
      fetchPreChallanData();
    }
  }, [isReset, isFind]);

  const handleDownload = () => {
    utils
      .callAPI(
        "get",
        `production/process/get-holdstock-list?page=${0}&per_page=${0}&product_id=${
          Object.keys(selectedProduct).length !== 0
            ? selectedProduct?.value
            : ""
        }`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          const csvHeader =
            "Product Name,Product Code,Quantity,Sales Order Number,";
          const csvRows = res?.result?.map((data, index) => {
            return `${data.ProductName},${
              data.ProductCode ? data.ProductCode : ""
            },${data.dr_qty},${data.order_id}`;
          });

          const csvContent = [csvHeader, ...csvRows].join("\n");
          generateCSV(csvContent, "on pre-hallan.csv");
        } else {
        }
      })
      .catch((err) => {});
  };

  function generateCSV(filteredData, fileName) {
    const blob = new Blob([filteredData], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <RB.Row className="mb-2">
        <RB.Col md={4}>
          <div className="mt-3">
            <RB.FloatingLabel
              controlId="productName"
              className="floating-label-fancy"
              // label="Product Name"
            >
              <Select
                options={options}
                value={selectedProduct}
                onChange={handleProductSelection}
                placeholder="Select Product Name"
                className="bom-productName-select"
                classNamePrefix="select"
                isClearable
                required
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={4} className="d-flex align-items-end">
          <div className="d-flex">
            <RB.Button
              variant="primary"
              className="me-2"
              onClick={handleSearch}
            >
              Search
            </RB.Button>
            <RB.Button variant="secondary" onClick={handleReset}>
              Reset
            </RB.Button>
          </div>
          <div className="ms-auto">
            <RB.Button
              size="sm"
              variant="primary"
              className="btn-circle"
              onClick={handleDownload}
              disabled={preChallanData?.result?.length == 0}
            >
              <DocumentDownload />
            </RB.Button>
          </div>
        </RB.Col>
      </RB.Row>
      <DataTable
        columns={columns}
        data={preChallanData?.result}
        highlightOnHover
        responsive
        pagination
        paginationServer
        paginationTotalRows={preChallanData.total}
        paginationPerPage={countPerPage}
        paginationComponentOptions={{
          noRowsPerPage: true,
        }}
        paginationComponent={() => (
          <CustomPagination
            currentPage={page}
            totalRows={preChallanData.total}
            rowsPerPage={countPerPage}
            onPageChange={handlePageChange}
          />
        )}
        // striped
        onChangePage={(page) => setPage(page)}
        persistTableHead
        customStyles={{
          head: {
            style: {
              fontSize: "0.875rem",
              fontWeight: "bold",
            },
          },
        }}
      />
    </>
  );
}

export default OnReChallan;
